var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AnalyticsTrigger } from '@telia-front/analytics';
import Anchor from '@telia-front/anchor';
const ButtonNavigation = (props) => {
    const { elementRef, behaviour, items, purpose = 'default', size, className, } = props;
    const BEM = () => {
        const classArray = ['btn-nav'];
        if (size) {
            classArray.push(`btn-nav--size-${size}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("ul", { className: BEM(), ref: elementRef, role: behaviour === 'tabs' ? 'tablist' : undefined, "aria-labelledby": props['aria-labelledby'] }, items.map((item, index) => {
        return (React.createElement(ButtonNavigationItem, Object.assign({}, item, { key: item.id || index, purpose: item.purpose || purpose, behaviour: behaviour })));
    })));
};
const ButtonNavigationItem = (props) => {
    const { id, label, current, purpose, behaviour } = props, rest = __rest(props, ["id", "label", "current", "purpose", "behaviour"]);
    const BEM = () => {
        const classArray = ['btn-nav__item', `btn-nav__item--purpose-${purpose}`];
        if (current) {
            classArray.push('is-current');
        }
        return classArray.join(' ');
    };
    const triggerId = () => {
        if (id) {
            return `${id}`;
        }
        return `${label}`;
    };
    return (React.createElement("li", { className: BEM(), id: id, role: behaviour === 'tabs' ? 'presentation' : undefined },
        React.createElement(AnalyticsTrigger, { trigger: {
                callback: 'onClick',
                id: triggerId(),
                elementId: triggerId(),
                elementType: 'link',
            } },
            React.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: "btn-nav__link" }), label))));
};
export { ButtonNavigation as default, };
